// pages/SsoCallback.jsx
import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Spin } from "antd";
import { ssoCheck, loginPrize } from "../../function/auth";

const SsoCallback = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [needPassword, setNeedPassword] = useState(false);
  const [ssoUser, setSsoUser] = useState({ email: "", name: "" });
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleLoginSuccess = ({ token, username, role, profileImage }) => {
    toast.success(`${username} Login Success`);
    localStorage.setItem("token", token);
    if (role === "employee") navigate("/employ-shop");
    else navigate("/");
    setTimeout(() => window.location.reload(), 500);
  };

  useEffect(() => {
    const code = params.get("code");
    if (!code) {
      toast.error("ไม่พบ code");
      return navigate("/login");
    }

    ssoCheck({ code })
      .then((res) => {
        if (!res.data.needPassword) {
          handleLoginSuccess(res.data);
        } else {
          setSsoUser({ email: res.data.email, name: res.data.name });
          setNeedPassword(true);
          setLoading(false);
        }
      })
      .catch(() => {
        toast.error("เข้าสู่ระบบผ่าน SSO ไม่สำเร็จ");
        navigate("/login");
      });
  }, []);

  const handleSubmitPassword = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const res = await loginPrize({
        username: ssoUser.email,
        password,
      });
      handleLoginSuccess({
        token: res.data.token,
        username: res.data.username,
        role: res.data.role,
        profileImage: res.data.profileImage?.url,
      });
    } catch (err) {
      toast.error("รหัสผ่านไม่ถูกต้อง");
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spin /> <p>กำลังตรวจสอบข้อมูล...</p>
      </div>
    );
  }

  if (needPassword) {
    return (
      <div style={{ maxWidth: 380, margin: "4rem auto" }}>
        <h5>ยืนยันตัวตนครั้งแรก</h5>
        <p style={{ color: "#888", fontSize: 13 }}>
          สวัสดี {ssoUser.name} กรุณากรอกรหัสผ่านของระบบ PrizeMed
          เพื่อยืนยันตัวตนครั้งแรก
        </p>
        <form onSubmit={handleSubmitPassword}>
          <div className="mb-2">
            <label style={{ fontSize: 13, color: "#666" }}>Email</label>
            <input className="form-control" value={ssoUser.email} disabled />
          </div>
          <div className="mb-3">
            <label style={{ fontSize: 13, color: "#666" }}>Password</label>
            <input
              className="form-control"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button
            type="submit"
            className="btn w-100"
            style={{ background: "#FF70A6", color: "#fff" }}
            disabled={submitting}
          >
            {submitting ? <Spin size="small" /> : "ยืนยัน"}
          </button>
        </form>
      </div>
    );
  }

  return null;
};

export default SsoCallback;